import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          用户热评
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          真实用户反馈 · 听听影迷们怎么说
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {commentItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.user}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {commentItems.slice(3).map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.user}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}